import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "ins-panel" }
const _hoisted_2 = { class: "ins-cab" }
const _hoisted_3 = {
  key: 0,
  class: "ins-info"
}
const _hoisted_4 = {
  key: 1,
  class: "ins-vacio"
}
const _hoisted_5 = { class: "ins-datos" }
const _hoisted_6 = { class: "ins-et" }
const _hoisted_7 = { class: "ins-val" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ins-res" }
const _hoisted_10 = { class: "ins-res-cab" }
const _hoisted_11 = { class: "ins-conteo" }
const _hoisted_12 = {
  key: 0,
  class: "ins-tabla"
}
const _hoisted_13 = {
  key: 1,
  class: "ins-nd"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "ins-vacio"
}
const _hoisted_16 = { class: "ins-nueva-res" }
const _hoisted_17 = ["value"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 3,
  class: "ins-form"
}
const _hoisted_20 = { class: "ins-grid" }
const _hoisted_21 = { class: "ins-acred-form" }
const _hoisted_22 = { class: "ins-check" }
const _hoisted_23 = { class: "ins-acciones" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "ins-error"
}

import { ref, computed, onMounted } from 'vue'
import {
  getInstitucionService,
  actualizarInstitucionService,
  agregarResolucionInstitucionService,
  type InstitucionSnies
} from '@/services/InstitucionSniesService'
import { eliminarResolucionService, getCatalogosSniesService, etiquetaTipoActo } from '@/services/ProgramaSniesService'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitucionPanel',
  setup(__props) {

/**
 * Datos de la institución y su organigrama.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const institucion = ref<InstitucionSnies | null>(null)
const cargando = ref(false)
const guardando = ref(false)
const editando = ref<Partial<InstitucionSnies> | null>(null)
const error = ref('')

const datos = computed(() => {
  const i = institucion.value
  if (!i) return []

  return [
    { etiqueta: 'Código SNIES', valor: i.codigo_snies ?? '—' },
    { etiqueta: 'NIT', valor: i.nit ?? '—' },
    { etiqueta: 'Carácter académico', valor: i.caracter_academico ?? '—' },
    { etiqueta: 'Naturaleza jurídica', valor: i.naturaleza_juridica ?? '—' },
    { etiqueta: 'Sector', valor: i.sector ?? '—' },
    { etiqueta: 'Principal o seccional', valor: i.principal_o_seccional ?? '—' },
    { etiqueta: 'Estado', valor: i.estado ?? '—' },
    { etiqueta: 'Domicilio', valor: [i.direccion, i.municipio, i.departamento].filter(Boolean).join(', ') || '—' },
    { etiqueta: 'Teléfono', valor: i.telefono ?? '—' },
    { etiqueta: 'Norma de creación', valor: i.norma_creacion ?? '—' },
    { etiqueta: 'Fecha de la norma', valor: i.fecha_norma ?? '—' },
    { etiqueta: 'Sitio web', valor: i.url ?? '—' }
  ]
})

function abrirEditar() {
  error.value = ''
  editando.value = { ...institucion.value }
}

// ── Actos administrativos ────────────────────────────────────────────
const tiposActo = ref<string[]>([])
const nuevaRes = ref({ tipo_acto: '', numero: '', fecha_ejecutoria: '', vigencia_anios: null as number | null })

/** Lo urgente se dice con palabras, no solo con color. */
const textoBandera = computed(() => {
  const meses = institucion.value?.resoluciones?.find(r => r.bandera === institucion.value?.bandera)?.meses_para_vencer
  if (meses == null) return ''
  return meses < 0 ? `vencida hace ${Math.abs(meses)} meses` : `vence en ${meses} meses`
})

async function agregarResolucion() {
  const resultado = await agregarResolucionInstitucionService({
    tipo_acto: nuevaRes.value.tipo_acto,
    numero: nuevaRes.value.numero || null,
    fecha_ejecutoria: nuevaRes.value.fecha_ejecutoria || null,
    vigencia_anios: nuevaRes.value.vigencia_anios
  })
  if (!resultado.ok) {
    error.value = resultado.error ?? 'No se pudo agregar la resolución'
    return
  }
  nuevaRes.value = { tipo_acto: '', numero: '', fecha_ejecutoria: '', vigencia_anios: null }
  await cargar()
}

// Editar y borrar usan los mismos endpoints que las de un programa.
async function quitarResolucion(id: number) {
  if (await eliminarResolucionService(id)) await cargar()
}

async function cargar() {
  cargando.value = true
  try {
    institucion.value = await getInstitucionService()
  } finally {
    cargando.value = false
  }
}

async function guardar() {
  if (!editando.value) return
  guardando.value = true
  error.value = ''
  try {
    const resultado = await actualizarInstitucionService(editando.value)
    if (!resultado.ok) {
      error.value = resultado.error ?? 'No se pudo guardar'
      return
    }
    editando.value = null
    await cargar()
  } finally {
    guardando.value = false
  }
}

onMounted(async () => {
  await cargar()
  // Mismo catálogo de actos que los programas: no hay dos listas que mantener.
  tiposActo.value = (await getCatalogosSniesService()).tipos_acto
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[23] || (_cache[23] = _createElementVNode("h4", null, "Caracterización ante el Ministerio (SNIES)", -1)),
      (!editando.value && institucion.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-ins",
            onClick: abrirEditar
          }, "Editar"))
        : _createCommentVNode("", true)
    ]),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Cargando…"))
      : (!institucion.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No hay institución registrada. Se siembra con los datos de la consulta pública del SNIES. "))
        : (!editando.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datos.value, (d) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: d.etiqueta,
                    class: "ins-d"
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(d.etiqueta), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(d.valor), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["ins-acreditacion", institucion.value.acreditacion_vigente ? 'ok' : 'no'])
              }, [
                (institucion.value.acreditacion_vigente)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[24] || (_cache[24] = _createElementVNode("strong", null, "Acreditada en alta calidad", -1)),
                      (institucion.value.vence_acreditacion_calculado)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · vence " + _toDisplayString(institucion.value.vence_acreditacion_calculado), 1))
                        : _createCommentVNode("", true),
                      (institucion.value.bandera)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(['ins-bandera', `ins-${institucion.value.bandera}`])
                          }, _toDisplayString(textoBandera.value), 3))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Sin acreditación institucional vigente", -1)),
                      _cache[26] || (_cache[26] = _createTextVNode(" — es distinta de la acreditación de cada programa. "))
                    ], 64))
              ], 2),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[27] || (_cache[27] = _createElementVNode("h5", null, "Actos administrativos", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(institucion.value.resoluciones?.length ?? 0), 1)
                ]),
                (institucion.value.resoluciones?.length)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                      _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Acto"),
                          _createElementVNode("th", null, "Número"),
                          _createElementVNode("th", null, "Ejecutoria"),
                          _createElementVNode("th", null, "Vigencia"),
                          _createElementVNode("th", null, "Vence"),
                          _createElementVNode("th")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(institucion.value.resoluciones, (r) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: r.id_resolucion
                          }, [
                            _createElementVNode("td", null, _toDisplayString(_unref(etiquetaTipoActo)(r.tipo_acto)), 1),
                            _createElementVNode("td", null, _toDisplayString(r.numero ?? '—'), 1),
                            _createElementVNode("td", null, _toDisplayString(r.fecha_ejecutoria ?? '—'), 1),
                            _createElementVNode("td", null, _toDisplayString(r.vigencia_anios ? r.vigencia_anios + ' años' : '—'), 1),
                            _createElementVNode("td", null, [
                              (r.fecha_vencimiento)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(['ins-vence', r.bandera ? `ins-${r.bandera}` : ''])
                                  }, _toDisplayString(r.fecha_vencimiento), 3))
                                : (_openBlock(), _createElementBlock("span", _hoisted_13, "no calculable"))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "btn-quitar-ins",
                                onClick: ($event: any) => (quitarResolucion(r.id_resolucion))
                              }, "×", 8, _hoisted_14)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_15, "Sin actos administrativos registrados.")),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nuevaRes.value.tipo_acto) = $event)),
                    class: "ins-input"
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("option", {
                      value: "",
                      disabled: ""
                    }, "Tipo de acto…", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposActo.value, (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t,
                        value: t
                      }, _toDisplayString(_unref(etiquetaTipoActo)(t)), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, nuevaRes.value.tipo_acto]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nuevaRes.value.numero) = $event)),
                    class: "ins-input ins-corto",
                    placeholder: "Número"
                  }, null, 512), [
                    [_vModelText, nuevaRes.value.numero]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nuevaRes.value.fecha_ejecutoria) = $event)),
                    type: "date",
                    class: "ins-input",
                    title: "Fecha de ejecutoria"
                  }, null, 512), [
                    [_vModelText, nuevaRes.value.fecha_ejecutoria]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nuevaRes.value.vigencia_anios) = $event)),
                    type: "number",
                    min: "1",
                    max: "20",
                    class: "ins-input ins-corto",
                    placeholder: "Años"
                  }, null, 512), [
                    [
                      _vModelText,
                      nuevaRes.value.vigencia_anios,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    class: "btn-ins btn-ins-ok",
                    disabled: !nuevaRes.value.tipo_acto,
                    onClick: agregarResolucion
                  }, " Agregar ", 8, _hoisted_18)
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "ins-ayuda-res" }, " El vencimiento no se escribe: se calcula como ejecutoria + vigencia, igual que en los programas. ", -1))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", null, [
                  _cache[31] || (_cache[31] = _createTextVNode("Nombre")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editando.value.nombre) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.nombre]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[32] || (_cache[32] = _createTextVNode("Código SNIES")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editando.value.codigo_snies) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.codigo_snies]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[33] || (_cache[33] = _createTextVNode("NIT")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editando.value.nit) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.nit]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[34] || (_cache[34] = _createTextVNode("Carácter académico")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editando.value.caracter_academico) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.caracter_academico]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[35] || (_cache[35] = _createTextVNode("Naturaleza jurídica")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editando.value.naturaleza_juridica) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.naturaleza_juridica]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[36] || (_cache[36] = _createTextVNode("Sector")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editando.value.sector) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.sector]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[37] || (_cache[37] = _createTextVNode("Principal o seccional")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editando.value.principal_o_seccional) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.principal_o_seccional]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[38] || (_cache[38] = _createTextVNode("Estado")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editando.value.estado) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.estado]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[39] || (_cache[39] = _createTextVNode("Departamento")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editando.value.departamento) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.departamento]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[40] || (_cache[40] = _createTextVNode("Municipio")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editando.value.municipio) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.municipio]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[41] || (_cache[41] = _createTextVNode("Dirección")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editando.value.direccion) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.direccion]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[42] || (_cache[42] = _createTextVNode("Teléfono")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editando.value.telefono) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.telefono]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[43] || (_cache[43] = _createTextVNode("Norma de creación")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editando.value.norma_creacion) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.norma_creacion]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[44] || (_cache[44] = _createTextVNode("Fecha de la norma")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editando.value.fecha_norma) = $event)),
                    type: "date",
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.fecha_norma]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[45] || (_cache[45] = _createTextVNode("Sitio web")),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editando.value.url) = $event)),
                    class: "ins-input"
                  }, null, 512), [
                    [_vModelText, editando.value.url]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((editando.value.acreditada_alta_calidad) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, editando.value.acreditada_alta_calidad]
                  ]),
                  _cache[46] || (_cache[46] = _createTextVNode(" Acreditada en alta calidad "))
                ]),
                (editando.value.acreditada_alta_calidad)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("label", null, [
                        _cache[47] || (_cache[47] = _createTextVNode("Resolución")),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editando.value.resolucion_acreditacion) = $event)),
                          class: "ins-input"
                        }, null, 512), [
                          [_vModelText, editando.value.resolucion_acreditacion]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[48] || (_cache[48] = _createTextVNode("Vence")),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((editando.value.vence_acreditacion) = $event)),
                          type: "date",
                          class: "ins-input"
                        }, null, 512), [
                          [_vModelText, editando.value.vence_acreditacion]
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn-ins",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (editando.value = null))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "btn-ins btn-ins-ok",
                  disabled: guardando.value,
                  onClick: guardar
                }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_24)
              ]),
              (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true)
            ]))
  ]))
}
}

})